import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { FormControl, TextField, Typography, Button } from "@mui/material";
import AlertModal from "../../Requirement/components/common/AlerModel";

const EmailInformation = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    newEmail: "",
    confirmEmail: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () =>
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.newEmail && !emailRegex.test(formData.newEmail))
      newErrors.newEmail = "Invalid email format";
    if (formData.newEmail !== formData.confirmEmail)
      newErrors.confirmEmail = "Emails do not match";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setSubmitted(true);
      setLoading(true);
      try {
        setModal({
          show: true,
          type: "info",
          title: "Info",
          message: "Email change functionality is not available at this time.",
          autoClose: false,
        });
      } catch (error) {
        console.error("Submission error:", error);
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: error.message || "Failed to update email.",
          autoClose: false,
        });
      } finally {
        setSubmitted(false);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_SELLERS_AND_FARMERS")) {
          await Auth.signOut();
          navigate("/login/seller-farmer");
        } else {
          setFormData((prev) => ({ ...prev, email: user.attributes.email }));
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/seller-farmer");
      }
    };
    checkUser();
  }, [navigate]);

  return (
    <div className="container mt-4">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="card p-4">
        <div className="table-header">
          <div className="header-text">
            <div className="head-text">Email Settings</div>
          </div>
          <div className="head-btn">
            <div className="submit-btn-form">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {submitted || loading ? "Submitting..." : "Update Email"}
              </Button>
            </div>
          </div>
        </div>
        <form className="row g-2">
          <div className="col-md-6">
            <FormControl fullWidth>
              <Typography variant="body2">Current Email</Typography>
              <TextField
                name="email"
                value={formData.email}
                size="small"
                sx={{ backgroundColor: "#f5f5f5" }}
                disabled
              />
            </FormControl>
          </div>
          <div className="col-md-6">
            <FormControl fullWidth>
              <Typography variant="body2">New Email</Typography>
              <TextField
                name="newEmail"
                value={formData.newEmail}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Enter new email"
                error={!!errors.newEmail}
                helperText={errors.newEmail}
              />
            </FormControl>
          </div>
          <div className="col-md-6">
            <FormControl fullWidth>
              <Typography variant="body2">Confirm New Email</Typography>
              <TextField
                name="confirmEmail"
                value={formData.confirmEmail}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="Confirm new email"
                error={!!errors.confirmEmail}
                helperText={errors.confirmEmail}
              />
            </FormControl>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailInformation;
